import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberSpaceMembershipRequest } from '../../utils/keys';
export const useMemberSpaceMembershipRequest = (options) => {
    const { fields = 'basic', useQueryOptions, variables } = options;
    const { client } = useTribeClient();
    const key = getMemberSpaceMembershipRequest();
    return useQuery(key, () => client.spaceMembership.getMemberRequests(variables, fields), {
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useMemberSpaceMembershipRequest.js.map